export const Colors = {
  black: "#000000",
  white: "#FFFFFF",
  destructGreen: "var(--color-accent)",
  destructRed: "var(--color-danger)",
  darkGrey: "#333333",
  lightGrey: "#4F4F4F",
  backgroundEggshell: "#F2F2F2",
  blueish: "#061529",
  terminalBg: "var(--color-bg)",
  terminalPanel: "var(--color-panel)",
  terminalBorder: "var(--color-border)",
  terminalText: "var(--color-text)",
  terminalMuted: "var(--color-muted)",
  terminalDim: "var(--color-dim)",
  terminalGlow: "var(--color-glow)",
  fieldBg: "var(--color-field-bg)",
  onAccent: "var(--color-on-accent)",
  headerBg: "var(--color-header)",
  frameShadow: "var(--color-frame-shadow)",
  menuShadow: "var(--color-menu-shadow)",
  accentFaint: "rgba(var(--color-accent-rgb), 0.06)",
  accentSoft: "rgba(var(--color-accent-rgb), 0.08)",
  accentWash: "rgba(var(--color-accent-rgb), 0.12)",
  accentRing: "rgba(var(--color-accent-rgb), 0.28)",
  accentFocus: "rgba(var(--color-accent-rgb), 0.35)",
};

export const MuiScheme = {
  dark: {
    primary: "#B2EC85",
    background: "#05080d",
    paper: "#0a1018",
  },
  light: {
    primary: "#2F6B1A",
    background: "#eef3e8",
    paper: "#f7faf4",
  },
};

export const Fonts = {
  mono: '"IBM Plex Mono", "SF Mono", "Fira Code", ui-monospace, Menlo, Monaco, Consolas, monospace',
};
